export default "__VITE_ASSET__CN14zNLw__"